import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import StateSiteUserPublisher from "../site/StateSiteUserPublisher";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Pagination from "../../partials/content/Pagination";

export default function AllPublisher() {
  const [allSitePublisher, setAllSitePublisher] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [urlWebSitePublisherSearchFilter, setUrlWebSitePublisherSearchFilter] =
    useState();

  useEffect(() => {
    getAllSitePublisher();
  }, [currentPage, urlWebSitePublisherSearchFilter]);

  const getAllSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allSitePublisher = await sendRequestGetAllSitePublisher(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allSitePublisher) {
      return;
    }

    setAllSitePublisher(allSitePublisher.site_publisher);
    setCountPage(allSitePublisher.count_page);
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (urlWebSitePublisherSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&url=${urlWebSitePublisherSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllSitePublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequest();
    let allSitePublisher;
    try {
      allSitePublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/publisher/site/active?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allSitePublisher.data.data;
  };

  const generateTableSitePublisher = () => {
    return (
      <>
        <div className="alert alert-warning ">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                جایگاه های تبلیغاتی شما به دو دسته وابسته به صفحه و مستقل از
                صفحه تقسیم می شود.
              </p>
            </li>
            <li>
              <p className="text-justify">
                برای مدیریت جایگاه های تبلیغاتی وابسته ابتدا باید صفحه بسازید.{" "}
              </p>
            </li>
          </ul>
        </div>

        <div class="container-fluid pb-2">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در آدرس سایت </label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="آدرس سایت را در اینجا وارد کنید"
                  onKeyUp={(e) =>
                    setUrlWebSitePublisherSearchFilter(e.target.value)
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>آدرس</td>
                <td>دسته بندی موضوع</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allSitePublisher.map((sitePublisher, index) => {
                return (
                  <tr>
                    <td>{helperNumber.toPersianNum(index + 1)}</td>
                    <td className="text-left">
                      <a target="_blank" href={sitePublisher.url}>
                        {sitePublisher.url}
                      </a>
                    </td>
                    <td></td>
                    <td>
                      <span className="pl-2">
                        <Link
                          to={`/page/all/publisher/${sitePublisher.id}`}
                          className="btn btn-primary"
                        >
                          نمایش صفحات جایگاه های تبلیغاتی
                        </Link>
                      </span>
                      <span>
                        <Link
                          to={`/positions/independent/all/web-site-publisher/${sitePublisher.id}`}
                          className="btn btn-info"
                        >
                          نمایش جایگاه های مستقل تبلیغاتی
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {countPage > 1 ? generatePagination() : <></>}
        </div>
        <div className="pt-2">
          <Link className="btn btn-primary" to="/positions/list">
            لیست جایگاه های تبلیغاتی شما{" "}
          </Link>
        </div>
      </>
    );
  };

  const generateDoNotHaveSitePublisher = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img
            className="img-fluid"
            src="/assets/img/do-not-have-website-publisher.svg"
          />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> شما در حال حاضر هیچ سایت نمایش دهنده فعال ندارید :(</p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar activeItem="all-publisher" />

      <div className="content-wrapper">
        <TitleBar title="جایگاه های تبلیغاتی شما" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {allSitePublisher.length === 0 &&
              urlWebSitePublisherSearchFilter == null
                ? generateDoNotHaveSitePublisher()
                : generateTableSitePublisher()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
